import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsRoutingModule } from './components-routing.module';
import { HeaderComponent } from '../layout/header/header.component';
import { LeftMenuComponent } from '../layout/left-menu/left-menu.component';
import { ComponentsComponent } from './components.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { SelectOasisIdDialogComponent } from './select-oasis-id-dialog/select-oasis-id-dialog.component';
import { MobileFindPwComponent } from './mobile/mobile-find-pw/mobile-find-pw.component';
import { MobileMypageComponent } from './mobile/mobile-mypage/mobile-mypage.component';
import { MobileHistoryComponent } from './mobile/mobile-history/mobile-history.component';
import { MobileLinkComponent } from './mobile/mobile-link/mobile-link.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [
    ComponentsComponent,
    HeaderComponent,
    LeftMenuComponent,
    WelcomeComponent,
    SelectOasisIdDialogComponent
  ],
  imports: [
    CommonModule,
    ComponentsRoutingModule,
    PipesModule
  ]
})
export class ComponentsModule { }
